"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTypeeLabels = exports.OrderType = void 0;
var OrderType;
(function (OrderType) {
    OrderType["PERSONAL"] = "PERSONAL";
    OrderType["ANONYMOUS"] = "ANONYMOUS";
    OrderType["RECAPITULATIVE"] = "RECAPITULATIVE";
})(OrderType || (exports.OrderType = OrderType = {}));
const OrderTypeeLabels = () => ({
    ['PERSONAL']: OrderType.PERSONAL,
    ['ANONYMOUS']: OrderType.ANONYMOUS,
    ['RECAPITULATIVE']: OrderType.RECAPITULATIVE,
});
exports.OrderTypeeLabels = OrderTypeeLabels;
